const getEmail = 'GET_EMAIL';
const checkYourEmail = 'CHECK_YOUR_EMAIL';

export default {
  getEmail,
  checkYourEmail,
};
